import React, {PropsWithChildren} from "react"
import {useNavigate} from "react-router-dom"
import {useModal} from "react-modal-hook"
import {startCase} from "lodash"
import classNames from "classnames"
import ReevaluateApplicationCancelingModal from "../../components/ReevaluateApplication/ReevaluateApplicationCancelingModal/ReevaluateApplicationCancelingModal"
import {ProductApplicationStatus} from "../../resources/productApplication"
import {productApplicationStatusTheme} from "../../components/Tag"
import TitleBar, {MetaItemProps, TitleBarAction} from "../../components/TitleBar/TitleBar"
import Button from "../../components/Button/Button"
import {MainSection} from "../../containers/MainSection/MainSection"
import {useListReturnPath} from "../../hooks/useListReturnPath"

type ProductApplicationDetailsProps = {
	productApplicationId: string
	status: ProductApplicationStatus
	title: string
	meta: Array<MetaItemProps>
	formId: string
}

export default function ProductApplicationDetails({
	children,
	productApplicationId,
	status,
	title,
	meta,
	formId,
}: PropsWithChildren<ProductApplicationDetailsProps>) {
	const listReturnPath = useListReturnPath("/applications/#tab=productApplication")
	const navigate = useNavigate()

	const [showCancelingModal, closeClosingModal] = useModal(() => (
		<ReevaluateApplicationCancelingModal
			close={closeClosingModal}
			onSavingCallback={() => navigate(`/product-applications/${productApplicationId}`)}
		/>
	))

	return (
		<div className="reevaluate-page">
			<TitleBar
				title={title}
				breadcrumbs={[{text: "Product Applications", path: listReturnPath}]}
				meta={meta}
				status={{
					text: startCase(status),
					className: classNames(
						"unit-tag",
						"outline",
						productApplicationStatusTheme(status),
						"large",
						"title-header-reevaluate"
					),
				}}
			>
				<TitleBarAction>
					<Button
						className="mr-3"
						prefixIcon="delete-close-x"
						size="normal"
						theme="danger"
						variant="outline"
						onClick={showCancelingModal}
					>
						<span>Cancel</span>
					</Button>

					<Button
						form={formId}
						type="submit"
						prefixIcon="approve-v-check-validation"
						size="normal"
						theme="success"
						variant="outline"
					>
						<span>Save changes</span>
					</Button>
				</TitleBarAction>
			</TitleBar>
			<MainSection>
				<React.Fragment>{children}</React.Fragment>
			</MainSection>
		</div>
	)
}
